// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_confirmation_container-module__container--4eNQj","overlay":"modal_confirmation_container-module__overlay--hf0Le"};